import LandingFrame from '../../assets/checker/LandingFrame.png';

export default function HeroSection() {
  return (
    <section className='min-h-[calc(100vh-64px)] md:min-h-[calc(100vh-72px)] relative bg-[#ECECEC] mx-4 md:mx-6 lg:mx-10 my-4 md:my-6 lg:my-8 rounded-[16px] md:rounded-[20px] overflow-hidden flex items-center'>
      {/* Mobile Background Image */}
      <div 
        className='lg:hidden absolute inset-0 bg-no-repeat bg-cover bg-center opacity-20'
        style={{
          backgroundImage: `url(${LandingFrame})`,
        }}
      />
      
      <div className='w-full flex flex-col lg:flex-row items-center justify-between px-6 md:px-10 lg:pl-16 lg:pr-0 py-8 md:py-12 lg:py-0 relative z-10'>
        {/* Left Content */}
        <div className='flex-shrink-0 w-full lg:max-w-[600px] text-center lg:text-left'>
          {/* Main Headline */}
          <h1 className='mb-4 md:mb-6'>
            <div className='text-[#BDBDBD] text-[36px] sm:text-[48px] md:text-[56px] lg:text-[72px] xl:text-[96px] font-bold leading-[1.15] tracking-tight'>
              Hire with
            </div>
            <div className='text-[#BDBDBD] text-[36px] sm:text-[48px] md:text-[56px] lg:text-[72px] xl:text-[96px] font-bold leading-[1.15] tracking-tight'>
              Confidence.
            </div>
            <div className='text-gray-900 text-[36px] sm:text-[48px] md:text-[56px] lg:text-[72px] xl:text-[96px] font-bold leading-[1.15] tracking-tight'>
              Verify with
            </div>
            <div className='text-gray-900 text-[36px] sm:text-[48px] md:text-[56px] lg:text-[72px] xl:text-[96px] font-bold leading-[1.15] tracking-tight'>
              Ease.
            </div>
          </h1>

          {/* Description */}
          <p className='text-gray-900 text-[13px] md:text-[14px] lg:text-[15px] leading-relaxed mb-6 md:mb-8 max-w-[500px] mx-auto lg:mx-0'>
            Podus Checker is a trusted platform that helps employers run comprehensive background checks on employees and candidates — fast, accurate, and reliable.
          </p>

          {/* CTA Buttons */}
          <div className='flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 md:gap-4'>
            <button className='w-full sm:w-auto bg-black text-white px-6 md:px-8 py-2.5 md:py-3 rounded-full text-[13px] md:text-[14px] font-medium hover:bg-gray-900 transition-colors'>
              Standard Check
            </button>
            <button className='w-full sm:w-auto bg-black text-white px-6 md:px-8 py-2.5 md:py-3 rounded-full text-[13px] md:text-[14px] font-medium hover:bg-gray-900 transition-colors'>
              Enhanced Check
            </button>
          </div>
        </div>

        {/* Right Content - Image (larger and blended into corners) - Desktop Only */}
        <div className='hidden lg:flex flex-1 items-center justify-end relative -mt-8 -mb-8 -mr-[20px]'>
          <img 
            src={LandingFrame} 
            alt='Background check showcase' 
            className='w-full max-w-[850px] h-auto object-contain scale-[1.2]'
          />
        </div>
      </div>
    </section>
  );
}
